.item {
  --drag-background: transparent;
  --position-sort-color: currentColor;
  --position-border-color: var(--neutral-400);
  --position-radius: 8px;
  --icon-border-color: var(--position-border-color);
  --icon-border-radius: var(--position-radius) 0 0 var(--position-radius);
  --item-border-radius: var(--position-radius);

  display: grid;
  grid-template-columns: 2rem 1fr;
  border-radius: var(--item-border-radius);
  border: 1px solid var(--position-border-color);
  background-color: var(--drag-background);
  align-items: center;
  font-size: 0.875rem;
  line-height: 1rem;
  cursor: pointer;
}

.item:is(button) {
  width: 100%;
}

.item:hover,
.item.active,
.item:has(input:checked) {
  --drag-background: var(--amber-600);
  --position-border-color: var(--amber-600);
  --position-sort-color: var(--neutral-50);
}

.item:has(input:focus-visible) {
  outline: 2px solid var(--purple-700);
  outline-offset: 2px;
}

.drag,
.icon {
  display: grid;
  place-content: center;
  height: 100%;
  border-radius: var(--icon-border-radius);
  color: var(--position-sort-color);
  border-right: 1px solid var(--icon-border-color);
}

.drag > span {
  display: none;
}

.drag[data-drag-handle]:hover {
  cursor: grab;

  & > span {
    display: block;
  }

  & > strong {
    display: none;
  }
}

.icon > span {
}

.content {
  --imgSize: 2.5rem;
  --contentRadius: calc(var(--position-radius) - 1px);

  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.5rem;
  margin: 1px;
  padding: calc(0.5rem - 2px) 0.5rem;
  background-color: var(--neutral-50);
  border-radius: 0 var(--contentRadius) var(--contentRadius) 0;
}

button .content {
  display: flex;
}

.content h3 {
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 500;
  margin: 0;
}

.icon + .content h3 {
  font-weight: 400;
}

.content img,
.content svg {
  display: block;
  width: var(--imgSize);
  height: var(--imgSize);
}

[data-sidebar-collapsed] aside {
  .item {
    --icon-border-color: transparent;
    --icon-border-radius: 0 var(--position-radius) 0 var(--position-radius);
    --item-border-radius: 0 var(--position-radius) 0 var(--position-radius);
    height: 1.75rem;
  }

  .content {
    display: none;
  }
}
